<template>
  <div class="f-shop-detail-rentRate tabs-item" id="rentRate">
    <div class="title">租务费率</div>
    <div class="content" v-if="defaultRatio.mallRatio || defaultRatio.mallRatio === 0">
      <div class="content-title">店铺租金扣点</div>
      <div class="content-value">
        <el-row class="row">
          <el-col class="col-title" :span="6">租金扣点：</el-col>
          <el-col class="col-value" :span="18">{{ (defaultRatio.mallRatio || defaultRatio.mallRatio === 0) ? defaultRatio.mallRatio + '%' : '' }}</el-col>
        </el-row>
      </div>

      <div class="content-title">店铺交易费率</div>
      <div class="content-value">
        <div class="pay-type-item" v-for="(item, index) in defaultRatio.settleFeeRatios" :key="index" >
          <el-row class="row">
            <el-col class="col-title" :span="6">支付方式：</el-col>
            <el-col class="col-value" :span="18">{{ item.payTypeName }}</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="6">费率：</el-col>
            <el-col class="col-value" :span="18">{{ item.ratio }}%</el-col>
          </el-row>
        </div>
      </div>
      <auth-button auth="finance:ratio:create" class="edit-btn">
        <div :class="storeDisable ? 'disabled custom-button' : 'custom-button'" @click="onEdit">编辑</div>
      </auth-button>
    </div>
    <div class="not-set" v-else>
      <auth-button auth="finance:ratio:create">
        <div :class="storeDisable ? 'disabled custom-button' : 'custom-button'" @click="onSet">设置租务费率</div>
      </auth-button>
      <div class="hint">还未设置租务费率（交易费率，租金扣点）</div>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
export default {
  name: "fsDetailRentRate",
  components: {
    AuthButton
  },
  props: {
    defaultRatio: {
      type: Object,
      default() {
        return {}
      }
    },
    storeDisable: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
    // this.$emit('initPage')
  },
  methods: {
    // 点击设置租务费率
    onSet() {
      if (this.storeDisable) {
        this.$baseMessage('「已关店」不支持设置租务费率', 'warning')
        return
      }
      this.gotoEdit()
    },

    // 点击编辑
    onEdit() {
      if (this.storeDisable) {
        this.$baseMessage('「已关店」不支持编辑', 'warning')
        return
      }
      this.gotoEdit()
    },

    // 跳转到编辑费率页
    gotoEdit() {
      this.$router.push(`/financeShop/index/setRate?id=${this.$route.query.id}`)
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.f-shop-detail-rentRate {
  min-height: 255px;
  padding: 20px;
  position: relative;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 4px;

  .content {
    position: relative;

    .content-title {
      color: #333;
      font-size: 16px;
      font-weight: 500;
    }

    .content-value {
      width: 500px;
      min-height: 20px;
      background: #F2F3F5;
      padding: 20px;
      margin: 20px 0;
    }

    .edit-btn {
      position: absolute;
      right: 0px;
      bottom: 0px;
    }
  }

  .custom-button {
    min-width: 110px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border-radius: 2px;
    background: #05C8AF;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #05C8AF;
    cursor: pointer;

    &:hover {
      background: #37d3bf;
      border: 1px solid #37d3bf;
    }

    &.disabled {
      background: #82e4d7;
      border: 1px solid #82e4d7;
      cursor: not-allowed;
    }
  }

  .not-set {
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .hint {
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
      margin-bottom: 55px;
    }
  }

  .row {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #666666;

    .col-title {
      text-align: right;
    }

    .col-value {
      color: #333333;
      font-weight: 500;
    }
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    margin-left: 20px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }
}
</style>
